"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initColorSwap(containerEl, swapEl) {
                if (!swapEl)
                    swapEl = containerEl;
                const bgColor = swapEl.style.backgroundColor;
                const color = swapEl.style.color;
                const swapColor = () => {
                    if (swapEl.style.backgroundColor === bgColor) {
                        swapEl.style.backgroundColor = color;
                        swapEl.style.color = bgColor;
                    }
                    else {
                        swapEl.style.backgroundColor = bgColor;
                        swapEl.style.color = color;
                    }
                };
                const disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(containerEl, 'mouseover', swapColor),
                    eXpress.html.addEventListener(containerEl, 'mouseout', swapColor)
                ]);
                return {
                    dispose: () => disposableEvents.dispose()
                };
            }
            content.initColorSwap = initColorSwap;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createExternalEditor(editorElement, priceElement, deps) {
                const castedEditorElement = editorElement;
                let externalOrder;
                let currentPvc;
                let amount = 1;
                const quantityParam = eXpress.utils.getParameter("quantity", window.location.href, false);
                if (quantityParam)
                    amount = Number(quantityParam);
                const { getPrice, getPvcByExternalCode, addToBasket } = deps;
                const countColoredImages = (text) => {
                    const textItems = text.split(';');
                    const regex = new RegExp("^([0-9]{2,})([a-zA-Z])$");
                    return textItems.filter(t => t !== '*' && regex.test(t) && t.slice(-1).toLowerCase() === 'p').length;
                };
                // External events that we need to subscribe to or set
                castedEditorElement.addEventListener("onOrderChanged", (event) => {
                    // console.log(event);
                });
                castedEditorElement.onUpdate = (o) => {
                    // console.log('Change in editor detected: ' + o.itemcode + ' ' + o.telegramtext);
                    externalOrder = o;
                    getPvcByExternalCode(o.itemcode).then(res => {
                        currentPvc = res;
                        getPrice(currentPvc, amount, countColoredImages(o.telegramtext)).then(res => {
                            priceElement.innerHTML = eXpress.utils.getPriceString(res.price.amount, res.price.currency);
                            // update content infoIcon
                            updatePriceToolTips(res);
                        });
                    });
                };
                const updatePriceToolTips = (data) => {
                    const tooltip = eXpress.html.querySelector(document, '.technical-price-tooltip', false);
                    if (!tooltip)
                        return;
                    const priceContainer = eXpress.html.querySelector(tooltip, '.technical-price-container', true);
                    const priceTemplate = eXpress.html.querySelectorAll(tooltip, '.technical-price-template')[0];
                    priceContainer.innerHTML = "";
                    priceContainer.appendChild(priceTemplate);
                    data.priceItems.forEach(item => {
                        // no properties to set => skip
                        if (!item.description && !item.calculationDescription && !item.itemTotal)
                            return;
                        const newCloneFromTemplate = priceTemplate.cloneNode(true);
                        newCloneFromTemplate.style.display = "";
                        const description = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-description', true);
                        item.description ? description.innerHTML = item.description : description.remove();
                        const calculation = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-calculation', true);
                        item.calculationDescription ? calculation.innerHTML = item.calculationDescription : calculation.remove();
                        const result = eXpress.html.querySelector(newCloneFromTemplate, '.technical-price-tooltip-result', true);
                        item.itemTotal ? result.innerHTML = item.itemTotal : result.remove();
                        const divider = eXpress.html.querySelector(newCloneFromTemplate, ".technical-price-divider", true);
                        const lastItem = data.priceItems.indexOf(item) == data.priceItems.length - 1;
                        divider.classList.toggle("u-hide", lastItem);
                        priceContainer.append(newCloneFromTemplate);
                    });
                };
                document.addEventListener('DOMContentLoaded', () => {
                    // Init of the text we had
                    castedEditorElement.order = {
                        itemcode: castedEditorElement.dataset["externalcode"] || '',
                        telegramtext: castedEditorElement.dataset["text"] || '',
                    };
                    const priceTooltipEls = eXpress.html.querySelectorAll(document, ".technical-price-tooltip");
                    const tooltips = priceTooltipEls.map(tooltip => {
                        return {
                            buttonEl: eXpress.html.querySelector(tooltip, '.technical-price-info-icon', true),
                            containerEl: eXpress.html.querySelector(tooltip, '.technical-price-tooltip-collapsible', true),
                            openClass: 'm-tooltip--is-open',
                        };
                    });
                    tooltips.forEach(components.main.initTooltip);
                    const addToBaskets = document.getElementsByClassName('technical-to-basket');
                    for (let i = 0; i < addToBaskets.length; i++) {
                        addToBaskets[i].classList.remove('u-hide');
                        addToBaskets[i].addEventListener('click', (e) => {
                            e.preventDefault();
                            if (externalOrder) {
                                addToBasket(externalOrder.itemcode, externalOrder.telegramtext, amount, countColoredImages(externalOrder.telegramtext));
                            }
                        });
                    }
                });
            }
            content.createExternalEditor = createExternalEditor;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
// SG organism: http://brandplatform.smartphoto.com/general/organisms/highlighted-tiles/
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            let Device;
            (function (Device) {
                Device[Device["Desktop"] = 1] = "Desktop";
                Device[Device["Tablet"] = 2] = "Tablet";
                Device[Device["Mobile"] = 3] = "Mobile";
            })(Device = content.Device || (content.Device = {}));
            function createHighlightedTiles(containerEl) {
                const desktopTileEls = eXpress.html.querySelectorAll(containerEl, ".o-highlighted-tiles__tile:not(.hide-on-desktop):not(.u-hide-on-desktop)");
                const tabletTileEls = eXpress.html.querySelectorAll(containerEl, ".o-highlighted-tiles__tile:not(.hide-on-tablet):not(.u-hide-on-tablet)");
                const truncateEls = eXpress.html.querySelectorAll(containerEl, '.technical-shave');
                const tileEl = eXpress.html.querySelectorAll(containerEl, '.o-highlighted-tiles__tile')[0];
                const headerAndTilesEl = eXpress.html.querySelector(containerEl, '.o-highlighted-tiles__header_and_tiles', true);
                const titleEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__title', false);
                const subTitleEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__subtitle', false);
                const textEl = eXpress.html.querySelector(headerAndTilesEl, '.m-header__text', false);
                let eventDisposable;
                let currentDevice;
                const getDevice = () => {
                    if (window.innerWidth <= 767) {
                        return Device.Mobile;
                    }
                    else if (window.innerWidth > 768 && window.innerWidth < 960) {
                        return Device.Tablet;
                    }
                    else {
                        return Device.Desktop;
                    }
                };
                const outerHeight = (el, includeOffset = true) => {
                    let height = includeOffset ? el.offsetHeight : 0;
                    const style = getComputedStyle(el);
                    height += parseInt(style.marginTop || '0', 10) + parseInt(style.marginBottom || '0', 10);
                    return height;
                };
                const calculateTruncateMaxHeight = () => {
                    let maxHeight = 0;
                    maxHeight = outerHeight(tileEl);
                    titleEl && (maxHeight -= outerHeight(titleEl));
                    subTitleEl && (maxHeight -= outerHeight(subTitleEl));
                    textEl && (maxHeight -= outerHeight(textEl, false));
                    return maxHeight;
                };
                const getTruncateOptions = () => {
                    currentDevice = getDevice();
                    const options = {};
                    switch (currentDevice) {
                        case Device.Desktop:
                            switch (desktopTileEls.length) {
                                case 0:
                                case 3:
                                    options.lines = 3;
                                    options.maxHeight = undefined;
                                    break;
                                default:
                                    options.maxHeight = calculateTruncateMaxHeight();
                                    options.lines = undefined;
                                    break;
                            }
                            break;
                        case Device.Tablet:
                            switch (tabletTileEls.length) {
                                case 1:
                                    options.maxHeight = calculateTruncateMaxHeight();
                                    options.lines = undefined;
                                    break;
                                default:
                                    options.lines = 2;
                                    options.maxHeight = undefined;
                                    break;
                            }
                            break;
                        default: // mobile
                            options.lines = 2;
                            options.maxHeight = undefined;
                            break;
                    }
                    return options;
                };
                const onResize = () => currentDevice !== getDevice() &&
                    truncatedEls.forEach(t => t.updateConfig(getTruncateOptions()));
                let truncatedEls = [];
                const init = () => {
                    truncatedEls = truncateEls.map(el => content.createTruncate(el, getTruncateOptions()));
                    eventDisposable = eXpress.html.addEventListener(window, "resize", eXpress.utils.debounce(onResize, 250));
                };
                //@ts-ignore
                document.documentMode
                    ? eXpress.utils.wait(250).then(() => init())
                    : init();
                return {
                    dispose: () => {
                        eventDisposable.dispose();
                        truncatedEls.forEach(t => t.dispose());
                    }
                };
            }
            content.createHighlightedTiles = createHighlightedTiles;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            class ProductSlider {
                constructor(containerEl, deps) {
                    this.configSquareSlider = {
                        slidesToShow: 6,
                        infinite: false,
                        arrows: false,
                        vertical: false,
                        verticalSwiping: false,
                        slide: '.technical-slideToShow',
                        variableWidth: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 5,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 960,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 3,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 415,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            }
                        ]
                    };
                    this.configLandscapeSlider = {
                        slidesToShow: 3,
                        infinite: false,
                        arrows: false,
                        vertical: false,
                        verticalSwiping: false,
                        variableWidth: true,
                        slide: '.technical-slideToShow',
                        responsive: [
                            {
                                breakpoint: 960,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            },
                            {
                                breakpoint: 450,
                                settings: {
                                    vertical: false,
                                    verticalSwiping: false,
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    infinite: false
                                }
                            }
                        ]
                    };
                    this.sliderEls = eXpress.html.querySelectorAll(containerEl, ".technical-slider");
                    const { isMobile } = deps;
                    this.isMobile = isMobile;
                    this.mobile = this.isMobile();
                    this.docWidth = window.innerWidth;
                    this.ioSlider = this.createIntersectionObserver();
                }
                initProductSliders() {
                    if (this.sliderEls) {
                        this.setVisibleSlides();
                        const sliders = this.initSliders();
                        if (sliders > 0) {
                            this.addHandlers();
                        }
                    }
                }
                setVisibleSlides() {
                    this.sliderEls.forEach(el => {
                        const technicalSlides = eXpress.html.querySelectorAll(el, ".technical-slide");
                        const technicalSlideElsCount = technicalSlides.length;
                        technicalSlides.forEach(slide => slide.classList.remove("m-product-slider__slide--center-mobile"));
                        const hideMobileSlideElsCount = eXpress.html.querySelectorAll(el, ".u-hide-on-mobile-full").length;
                        technicalSlides.forEach(slide => {
                            if (this.mobile && technicalSlideElsCount - hideMobileSlideElsCount === 1 && !slide.classList.contains("u-hide-on-mobile-full"))
                                $(slide).addClass("m-product-slider__slide--center-mobile");
                            if (!slide.classList.contains("technical-slideToShow")) {
                                $(slide).addClass("technical-slideToShow");
                            }
                        });
                    });
                    if (this.mobile) {
                        this.sliderEls.forEach(el => {
                            eXpress.html.querySelectorAll(el, ".u-hide-on-mobile-full").forEach(slide => $(slide).removeClass("technical-slideToShow"));
                        });
                    }
                    else {
                        this.sliderEls.forEach(el => {
                            eXpress.html.querySelectorAll(el, ".u-hide-on-desktop").forEach(slide => $(slide).removeClass("technical-slideToShow"));
                        });
                    }
                }
                initSliders() {
                    const slidersToInit = this.sliderEls
                        .filter(el => eXpress.html.querySelectorAll(el, ".technical-slideToShow").length >= 2
                        && $(el).data("slider-format") !== undefined);
                    if (this.ioSlider) {
                        slidersToInit.forEach(el => this.ioSlider.observe(el));
                    }
                    else {
                        slidersToInit.filter(el => $(el).data("slider-format").toLowerCase() === "square").forEach(el => {
                            this.initSquareSlider(el);
                        });
                        slidersToInit.filter(el => $(el).data("slider-format").toLowerCase() === "landscape").forEach(el => {
                            this.initLandscapeSlider(el);
                        });
                    }
                    return slidersToInit.length;
                }
                initSquareSlider(el) {
                    this.initSliderWithConfig(el, this.configSquareSlider);
                }
                initLandscapeSlider(el) {
                    this.configLandscapeSlider.slidesToShow = $(el).data("slidestoshow");
                    this.initSliderWithConfig(el, this.configLandscapeSlider);
                }
                initSliderWithConfig(el, config) {
                    $(el).slick(config);
                    this.addEmptySlideToLandscapeSliderIfNeeded(el);
                    this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                    this.addOnAfterChange(el);
                }
                createIntersectionObserver() {
                    if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        return new IntersectionObserver((entries, observer) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting) {
                                    if ($(entry.target).data("slider-format").toLowerCase() === "square")
                                        this.initSquareSlider(entry.target);
                                    if ($(entry.target).data("slider-format").toLowerCase() === "landscape")
                                        this.initLandscapeSlider(entry.target);
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { rootMargin: "0px 0px 0px 0px" });
                    }
                }
                // Decide whether or not to add an extra empty slide (when less then 90% of the last slide in the slider is visible)
                addEmptySlideToLandscapeSliderIfNeeded(slider) {
                    const parent = eXpress.html.getParentWithClassName(slider, "m-product-slider");
                    if (parent) {
                        const slidesToShow = $(slider).slick('slickGetOption', 'slidesToShow');
                        const currentSlideEl = eXpress.html.querySelectorAll(slider, ".slick-slide")[0];
                        const sliderWidth = eXpress.html.querySelector(slider, ".slick-list", true).getBoundingClientRect().width;
                        const slideWidth = currentSlideEl.getBoundingClientRect().width;
                        const slideRightMargin = parseInt(window.getComputedStyle(currentSlideEl).marginRight || "0", 10);
                        const leftOver = sliderWidth - (slideWidth * parseInt(slidesToShow + "" || "1", 10)) - (slideRightMargin * (parseInt(slidesToShow + "" || "1", 10) - 1));
                        const emptySlide = eXpress.html.querySelector(slider, ".technical-empty-slide", false);
                        const shouldAddEmptySlide = leftOver < 0 && Math.abs(leftOver) > slideWidth * 0.1;
                        if (!emptySlide && shouldAddEmptySlide) {
                            $(slider).slick('slickAdd', '<div class="technical-slideToShow technical-empty-slide"></div>');
                        }
                    }
                }
                removeEmptySlide(slider) {
                    const emptySlide = eXpress.html.querySelector(slider, ".technical-empty-slide", false);
                    let emptySlideIndex = -1;
                    if (emptySlide && emptySlide.dataset && emptySlide.dataset.slickIndex) {
                        emptySlideIndex = +emptySlide.dataset.slickIndex;
                        $(slider).slick('slickRemove', emptySlideIndex);
                    }
                }
                onWindowResize() {
                    // When you scroll in some mobile browsers they show a scrollbar. This actually triggers in the resize event => We do not want this!
                    // Simple trick is to check if th width of the window changed
                    if (window.innerWidth === this.docWidth)
                        return;
                    this.docWidth = window.innerWidth;
                    this.sliderEls.filter(el => $(el).data("slider-format").toLowerCase() === "landscape" && el.classList.contains("slick-initialized")).forEach(el => this.removeEmptySlide(el));
                    if (this.mobile !== this.isMobile()) {
                        this.mobile = this.isMobile();
                        this.setVisibleSlides();
                        this.sliderEls.forEach(el => {
                            const visibleSlides = eXpress.html.querySelectorAll(el, ".technical-slideToShow");
                            if (visibleSlides.length < 2 && el.classList.contains("slick-initialized")) {
                                $(el).slick("unslick");
                            }
                            else if (visibleSlides.length >= 2 && el.classList.contains("slick-initialized")) {
                                $(el).slick('resize');
                                $(el).slick('refresh');
                                this.addEmptySlideToLandscapeSliderIfNeeded(el);
                                this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                                this.addOnAfterChange(el);
                            }
                            else {
                                if (this.ioSlider) {
                                    this.ioSlider.observe(el);
                                }
                                else {
                                    if ($(el).data("slider-format").toLowerCase() === "square")
                                        this.initSquareSlider(el);
                                    if ($(el).data("slider-format").toLowerCase() === "landscape")
                                        this.initLandscapeSlider(el);
                                }
                            }
                        });
                    }
                    else {
                        this.sliderEls.filter(el => el.classList.contains("slick-initialized")).forEach(el => {
                            this.addEmptySlideToLandscapeSliderIfNeeded(el);
                            this.resizeSlidesToHighestWhenFirstSlideImageIsLoaded(el);
                        });
                    }
                }
                resizeSlidesToHighestWhenFirstSlideImageIsLoaded(sliderEl) {
                    const me = this;
                    const classToRemove = this.isMobile() ? 'u-hide-on-mobile-full' : 'u-hide-on-desktop';
                    const slideEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide:not(." + classToRemove + ")");
                    if (slideEls.length === 0)
                        return;
                    const img = eXpress.html.querySelector(slideEls[0], ".technical-slide-imageContainer img", true);
                    if (img.classList.contains("loaded")) {
                        this.resizeSlidesToHighest(sliderEl, slideEls);
                    }
                    else {
                        if ('MutationObserver' in window) {
                            const observer = new MutationObserver(function (mutations) {
                                mutations.forEach((mutation) => {
                                    if (mutation.attributeName === "class") {
                                        const el = mutation.target;
                                        if (el.classList.contains("loaded")) {
                                            me.resizeSlidesToHighest(sliderEl, slideEls);
                                            observer.disconnect();
                                        }
                                    }
                                });
                            });
                            observer.observe(img, { attributes: true });
                        }
                        else {
                            // Check first if the image of the first slide has already been loaded (lazy loading!)-> If not, redo it onload
                            if (!img.classList.contains('loaded') && !img.classList.contains('loading')) {
                                if (!img.onload)
                                    img.onload = () => { this.resizeSlidesToHighest(sliderEl, slideEls); };
                                return;
                            }
                        }
                    }
                }
                resizeSlidesToHighest(sliderEl, slideEls) {
                    let slideImageHeight = 0;
                    let maxHeightSlideEl = 0;
                    let maxHeightSlideTitleEl = 0;
                    let maxHeightSlideTitleTitleEl = 0;
                    let maxHeightSlideTitleSubTitleEl = 0;
                    let bottomLinkHeight;
                    // Remove aspect ratio from parent container when image is loaded
                    const imageEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-imageContainer img");
                    imageEls.forEach(imgEl => {
                        if (imgEl.classList.contains('loaded')) {
                            this.removeAspectRatio(imgEl);
                        }
                        else {
                            if (!imgEl.onload)
                                imgEl.onload = () => { this.removeAspectRatio(imgEl); };
                        }
                    });
                    // Reset properties
                    slideEls.forEach(slideEl => {
                        const titleEl = eXpress.html.querySelector(slideEl, ".technical-slide-title", false);
                        if (slideEl.style.removeProperty) {
                            slideEl.style.removeProperty("height");
                            if (titleEl)
                                titleEl.style.removeProperty("height");
                        }
                        else {
                            slideEl.style.height = '';
                            if (titleEl)
                                titleEl.style.height = '';
                        }
                    });
                    // Get Properties
                    slideEls.forEach(slideEl => {
                        if (!eXpress.html.isElementVisible(slideEl))
                            return;
                        const heightSlideTitleTitleEl = 0;
                        const heightSlideTitleSubTitleEl = 0;
                        const imageContainerEl = eXpress.html.querySelector(slideEl, ".technical-slide-imageContainer", true);
                        const img = eXpress.html.querySelector(imageContainerEl, "img", true);
                        // Update WEB-3303 => We should only return when the image isn't loaded yet for the first slide
                        if (slideEls[0] === slideEl && !img.classList.contains('loaded') && !img.classList.contains('loading'))
                            return;
                        let heightSlideTitleEl = 0;
                        const title = eXpress.html.querySelector(slideEl, ".technical-tile-title", false);
                        if (title)
                            heightSlideTitleEl += eXpress.html.getHeightWithMargins(title);
                        const subTitle = eXpress.html.querySelector(slideEl, ".technical-tile-subtitle", false);
                        if (subTitle)
                            heightSlideTitleEl += eXpress.html.getHeightWithMargins(subTitle);
                        const heightSlideEl = slideEl.offsetHeight;
                        if (heightSlideEl > maxHeightSlideEl)
                            maxHeightSlideEl = heightSlideEl;
                        if (heightSlideTitleEl > maxHeightSlideTitleEl)
                            maxHeightSlideTitleEl = heightSlideTitleEl;
                        if (heightSlideTitleTitleEl > maxHeightSlideTitleTitleEl)
                            maxHeightSlideTitleTitleEl = heightSlideTitleTitleEl;
                        if (heightSlideTitleSubTitleEl > maxHeightSlideTitleSubTitleEl)
                            maxHeightSlideTitleSubTitleEl = heightSlideTitleSubTitleEl;
                        // With the lazy loading we sometimes get the wrong value here as the image is not completely loaded. Only update this value once it is completely loaded
                        // Update WEB-3303 => All imageContainers should have the same height, Only set for the first slide. If the image of the first slide isn't loaded yet, we return on line 280
                        if (slideEls[0] === slideEl)
                            slideImageHeight = imageContainerEl.offsetHeight;
                    });
                    // Set Properties
                    slideEls.forEach(slideEl => {
                        const titleEl = eXpress.html.querySelector(slideEl, ".technical-slide-title", false);
                        slideEl.style.height = `${maxHeightSlideEl}px`;
                        if (titleEl)
                            titleEl.style.height = `${maxHeightSlideTitleEl}px`;
                    });
                    // Necessary for buttons
                    bottomLinkHeight = maxHeightSlideEl - (maxHeightSlideTitleEl + slideImageHeight);
                    if (bottomLinkHeight < 0)
                        bottomLinkHeight = 0; // Sometimes we get a negative value
                    const bottomValue = (bottomLinkHeight + (slideImageHeight / 2)) - 14;
                    this.setPositionButtons(sliderEl, bottomValue);
                }
                removeAspectRatio(imageEl) {
                    const imgContainerEl = eXpress.html.getParentWithClassName(imageEl, "technical-slide-imageContainer");
                    if (imgContainerEl)
                        imgContainerEl.style.removeProperty("--aspect-ratio");
                }
                // The buttons are normally loaded on slider init but because of layout shifts I've decided to load the buttons when we know where they should be placed (know the bottom value)
                setPositionButtons(sliderEl, bottomValue) {
                    if (!sliderEl)
                        return;
                    const arrows = $(sliderEl).slick("slickGetOption", "arrows");
                    if (!arrows) {
                        const prevButtonString = '<button class="a-button a-button--disabled a-button--slider-button m-product-slider__button--prev icon-arrow-left technical-slide-button" style="bottom:' + bottomValue + 'px" aria-label="Previous"></button>';
                        const nextButtonString = '<button class="a-button a-button--slider-button m-product-slider__button--next icon-arrow-right technical-slide-button" style="bottom:' + bottomValue + 'px" aria-label="Next"></button>';
                        $(sliderEl).slick("slickSetOption", {
                            arrows: true,
                            prevArrow: prevButtonString,
                            nextArrow: nextButtonString,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 960,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 600,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 450,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                },
                                {
                                    breakpoint: 415,
                                    settings: {
                                        arrows: true,
                                        prevArrow: prevButtonString,
                                        nextArrow: nextButtonString,
                                    }
                                }
                            ]
                        }, false);
                        $(sliderEl).slick('refresh');
                    }
                    else {
                        const buttonsEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-button");
                        buttonsEls.forEach(sliderButtonEl => {
                            sliderButtonEl.style.bottom = `${bottomValue}px`;
                        });
                    }
                }
                addOnAfterChange(sliderEl) {
                    $(sliderEl).on("afterChange", function (event, slick, currentSlide) {
                        const buttonsEls = eXpress.html.querySelectorAll(sliderEl, ".technical-slide-button");
                        buttonsEls.forEach(buttonEl => {
                            if (buttonEl.classList.contains("slick-disabled") && !buttonEl.classList.contains("a-button--disabled"))
                                buttonEl.classList.add("a-button--disabled");
                            else
                                buttonEl.classList.remove("a-button--disabled");
                        });
                    });
                }
                addHandlers() {
                    window.addEventListener('resize', eXpress.utils.debounce(this.onWindowResize.bind(this), 250));
                }
            }
            content.ProductSlider = ProductSlider;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBar(containerEl, dependencies) {
                const { onClick, clearActiveBar } = dependencies;
                const barEl = eXpress.html.querySelector(containerEl, ".m-review-bars__review-bar", true);
                const quantityEl = eXpress.html.querySelector(containerEl, ".m-review-bars__reviews-quantity", true);
                const enabledClass = "m-review-bars__review-link";
                const disabledClass = "m-review-bars__review-no-link";
                const activeClass = "m-review-bars__review-link--active";
                let startValue = 0;
                const isEnabled = () => containerEl.classList.contains(enabledClass);
                const isDisabled = () => containerEl.classList.contains(disabledClass);
                function getStartValue() {
                    return +(containerEl.getAttribute('data-star-value') || 0);
                }
                const onClickEvent = () => {
                    clearActiveBar();
                    containerEl.classList.add(activeClass);
                    onClick(startValue);
                };
                const enable = () => {
                    if (isDisabled())
                        containerEl.classList.remove(disabledClass);
                    containerEl.classList.add(enabledClass);
                    containerEl.addEventListener("click", onClickEvent);
                };
                const updateBarPercentage = (totalNumberOfReviews, starAmount) => {
                    const barActiveEl = eXpress.html.querySelector(barEl, ".m-review-bars__review-bar-active", true);
                    const percentage = totalNumberOfReviews > 0 ? starAmount * 100 / totalNumberOfReviews : 0;
                    barActiveEl.style.width = percentage + "%";
                };
                const disable = () => {
                    if (isEnabled())
                        containerEl.classList.remove(enabledClass);
                    containerEl.classList.add(disabledClass);
                    containerEl.removeEventListener("click", onClickEvent);
                };
                const update = (totalNumberOfReviews, amount) => {
                    quantityEl.innerHTML = amount + "";
                    updateBarPercentage(totalNumberOfReviews, amount);
                    if (amount > 0 && isDisabled())
                        enable();
                    if (amount === 0 && isEnabled())
                        disable();
                };
                const init = () => {
                    deInit();
                    startValue = getStartValue();
                    if (isEnabled())
                        containerEl.addEventListener("click", onClickEvent);
                };
                const deInit = () => {
                    if (isEnabled())
                        containerEl.removeEventListener("click", onClickEvent);
                };
                const dispose = () => {
                    deInit();
                };
                init();
                return {
                    dispose,
                    update,
                    startValue
                };
            }
            content.createReviewBar = createReviewBar;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBars(containerEl, dependencies) {
                let eventDisposable;
                const { onClick } = dependencies;
                const reviewBarEls = eXpress.html.querySelectorAll(containerEl, '.m-review-bars__review-link, .m-review-bars__review-no-link');
                const reviewBarComponents = [];
                const reviewBarsTotalLinkEl = eXpress.html.querySelector(containerEl, '.m-review-bars__reviews-link', true);
                const clearActiveBar = () => reviewBarEls.forEach(el => eXpress.html.removeClass(el, 'm-review-bars__review-link--active'));
                const deinit = () => eventDisposable && eventDisposable.dispose();
                const updateAmounts = (totalReviews, starAmounts, resetActiveBar = false) => {
                    const replaceAmountBetweenParentheses = (text, amount) => {
                        return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
                    };
                    if (resetActiveBar)
                        clearActiveBar();
                    reviewBarComponents.forEach(barcomponent => {
                        const reviewStar = starAmounts.find(x => x.key === barcomponent.startValue);
                        barcomponent.update(totalReviews, !reviewStar ? 0 : reviewStar.value); // no reviews for star ? => reset
                    });
                    const innerTextEl = eXpress.html.querySelector(reviewBarsTotalLinkEl, 'span', true);
                    innerTextEl.innerText = replaceAmountBetweenParentheses(innerTextEl.innerText, totalReviews + "");
                };
                const init = () => {
                    deinit();
                    reviewBarEls.forEach(el => {
                        reviewBarComponents.push(content.createReviewBar(el, { onClick, clearActiveBar }));
                    });
                    eventDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(reviewBarsTotalLinkEl, "click", () => {
                            onClick(0);
                            clearActiveBar();
                        }),
                    ]);
                };
                const dispose = () => {
                    deinit();
                };
                init();
                return {
                    dispose,
                    updateAmounts
                };
            }
            content.createReviewBars = createReviewBars;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createShowMoreButton(containerEl, options) {
                const onClick = () => options.onClick();
                const enable = () => {
                    const buttonEl = eXpress.html.querySelector(containerEl, ".a-button");
                    containerEl.removeEventListener("click", onClick);
                    containerEl.addEventListener("click", onClick);
                    if (buttonEl)
                        buttonEl.classList.add("a-button--active");
                };
                const disable = () => {
                    containerEl.removeEventListener("click", onClick);
                };
                const show = () => {
                    containerEl.style.display = '';
                };
                const hide = () => {
                    containerEl.style.display = 'none';
                };
                const dispose = () => {
                    disable();
                };
                enable();
                return {
                    show,
                    hide,
                    enable,
                    disable,
                    dispose,
                };
            }
            content.createShowMoreButton = createShowMoreButton;
            function createPaginationControl(containerEl, options) {
                const buttonTemplateEl = containerEl.querySelector(".m-review-blocks-controls__button");
                const leftControlEL = buttonTemplateEl.cloneNode(true);
                eXpress.html.querySelector(leftControlEL, 'button', true)
                    .className += " icon-arrow-left m-review-blocks-controls__pagination-button";
                eXpress.html.hide(leftControlEL);
                const rightControlEL = buttonTemplateEl.cloneNode(true);
                eXpress.html.querySelector(rightControlEL, 'button', true)
                    .className += " icon-arrow-right m-review-blocks-controls__pagination-button";
                eXpress.html.hide(rightControlEL);
                const reviewBlocksControlEl = document.getElementsByClassName('m-review-blocks-controls');
                reviewBlocksControlEl[1].insertAdjacentElement('afterbegin', leftControlEL);
                reviewBlocksControlEl[1].insertAdjacentElement('beforeend', rightControlEL);
                eXpress.html.remove(buttonTemplateEl);
                let numberedButtonEls = [];
                const amountOfPagesToShow = parseInt(containerEl.getAttribute('data-amount-of-pages'), 10) || 5;
                let { numberOfPages } = options;
                let indexOffset = 0;
                let selectedPage;
                const onNumberedButtonClicked = (e) => {
                    const buttonEl = e.currentTarget;
                    options.onClick(parseInt(buttonEl.textContent, 10));
                };
                const showArrowControl = (show, el) => {
                    if (show) {
                        eXpress.html.show(el);
                        el.removeEventListener("click", onClickArrowControl);
                        el.addEventListener("click", onClickArrowControl);
                    }
                    else {
                        eXpress.html.hide(el);
                        el.removeEventListener("click", onClickArrowControl);
                    }
                };
                const updatePaginations = (pages, pageNumber) => {
                    if (pageNumber) {
                        if (pageNumber === 1)
                            indexOffset = 0;
                        selectedPage = pageNumber;
                    }
                    if (pages)
                        numberOfPages = pages;
                    numberedButtonEls = [];
                    eXpress.html.querySelectorAll(containerEl, ".m-review-blocks-controls__button.numbered-control")
                        .forEach(eXpress.html.remove);
                    const indexCondition = Math.min((numberOfPages + 1), (amountOfPagesToShow + 1 + indexOffset));
                    for (let index = 1 + indexOffset; index < indexCondition; index++) {
                        const buttonCloneEl = buttonTemplateEl.cloneNode(true);
                        buttonCloneEl.classList.add('numbered-control');
                        if (selectedPage === index) {
                            const activeButtonEl = eXpress.html.querySelector(buttonCloneEl, ".a-button");
                            if (activeButtonEl)
                                activeButtonEl.classList.add("a-button--active");
                        }
                        else {
                            buttonCloneEl.addEventListener("click", onNumberedButtonClicked);
                        }
                        eXpress.html.querySelector(buttonCloneEl, '.a-button--review', true)
                            .insertAdjacentText('beforeend', index.toString());
                        numberedButtonEls.push(buttonCloneEl);
                    }
                    const docFrag = document.createDocumentFragment();
                    docFrag.append(...numberedButtonEls);
                    rightControlEL.parentNode.insertBefore(docFrag, rightControlEL);
                    toggleArrowControls();
                };
                const toggleArrowControls = () => {
                    showArrowControl((amountOfPagesToShow + indexOffset) < numberOfPages, rightControlEL);
                    showArrowControl((indexOffset - amountOfPagesToShow) >= 0, leftControlEL);
                };
                const onClickArrowControl = (e) => {
                    const controlEl = e.currentTarget;
                    const isLeft = controlEl.querySelector('.icon-arrow-left');
                    if (isLeft)
                        indexOffset -= amountOfPagesToShow;
                    else
                        indexOffset += amountOfPagesToShow;
                    updatePaginations();
                };
                // init pagination controls
                updatePaginations(numberOfPages, 1);
                return {
                    updatePaginations,
                    dispose: () => {
                        leftControlEL.removeEventListener("click", onClickArrowControl);
                        rightControlEL.removeEventListener("click", onClickArrowControl);
                        numberedButtonEls.forEach(e => e.removeEventListener("click", onNumberedButtonClicked));
                    }
                };
            }
            content.createPaginationControl = createPaginationControl;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewBlocks(containerEl, options) {
                const { productReviewsNameLabel, productReviewsAnonymousLabel = "Anonymous" } = options;
                const reviewTemplateEl = eXpress.html.querySelector(containerEl, '.m-review-block.template', true);
                eXpress.html.remove(reviewTemplateEl);
                const createUserReview = (review) => {
                    const reviewTemplateCloneEl = reviewTemplateEl.cloneNode(true);
                    // stars block
                    const reviewStarsEl = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__stars", true);
                    const fullStarsEl = eXpress.html.querySelector(reviewStarsEl, ".a-review-stars__full", true);
                    fullStarsEl.style.width = `${review.score * 100 / 5}%`; // TODO : get maxscore
                    // review
                    if (review.comment)
                        eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__review", true)
                            .insertAdjacentText('beforeend', review.comment);
                    // user info
                    const reviewerBlockEL = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__reviewer", true);
                    // if no label provided -> don't show names at all
                    if (productReviewsNameLabel) {
                        const name = `${review.firstName || ""} ${review.lastName || ""}`;
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__reviewer-name", true)
                            .insertAdjacentText('beforeend', `${productReviewsNameLabel.replace('{0}', name.trim() || productReviewsAnonymousLabel)}`);
                    }
                    else {
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__reviewer-name", true).style.display = 'none';
                    }
                    if (review.reviewDate)
                        eXpress.html.querySelector(reviewerBlockEL, ".m-review-blocks__review-date", true)
                            .insertAdjacentText('beforeend', review.reviewDate);
                    // comment block
                    const commentBlockEl = eXpress.html.querySelector(reviewTemplateCloneEl, ".m-review-blocks__answer-block", true);
                    if (review.feedback && review.feedbackDate) {
                        eXpress.html.querySelector(commentBlockEl, ".m-review-blocks__answer-block__answer-date", true)
                            .insertAdjacentText('beforeend', review.feedbackDate);
                        eXpress.html.querySelector(commentBlockEl, ".m-review-blocks__answer-block__answer", true)
                            .insertAdjacentHTML("beforeend", `<span>${review.feedback}</span>`);
                    }
                    else {
                        eXpress.html.remove(commentBlockEl);
                    }
                    eXpress.html.show(reviewTemplateCloneEl);
                    return reviewTemplateCloneEl;
                };
                const addReviews = (productCategoryReviews, replace = false) => {
                    const reviewEls = productCategoryReviews.map(r => createUserReview(r));
                    if (replace)
                        clear();
                    containerEl.append(...reviewEls);
                };
                const clear = () => containerEl.innerHTML = '';
                return {
                    addReviews,
                    clear,
                };
            }
            content.createReviewBlocks = createReviewBlocks;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createReviewLanguageSelect(containerEl, dependencies) {
                let eventDisposable;
                const { onSelect } = dependencies;
                const languageSelectEl = eXpress.html.querySelector(containerEl, ".technical-review-language-selector", true);
                const deInit = () => eventDisposable && eventDisposable.dispose();
                const init = () => {
                    deInit();
                    eventDisposable = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(languageSelectEl, "change", () => {
                            onSelect(languageSelectEl.value);
                        }),
                    ]);
                };
                const dispose = () => {
                    deInit();
                };
                function selectedLanguage() {
                    return languageSelectEl.value;
                }
                const updateAmounts = (reviewAmounts) => {
                    let totalReviews = 0;
                    let languagesCount = 0;
                    const replaceAmountBetweenParentheses = (text, amount) => {
                        return text.replace(/ \([0-9]*?\)/g, ' (' + amount + ')');
                    };
                    [].slice.call(languageSelectEl.options).forEach(o => {
                        const option = o;
                        if (option.value === "all") {
                            totalReviews = reviewAmounts.filter(r => r.key === option.value)[0].value;
                            option.text = replaceAmountBetweenParentheses(option.text, totalReviews + "");
                        }
                        else if (option.value !== "other" && option.value !== "all") {
                            const languageCount = reviewAmounts.filter(r => r.key === option.value)[0].value;
                            languagesCount += languageCount;
                            option.text = replaceAmountBetweenParentheses(option.text, languageCount + "");
                        }
                        else if (option.value === "other") {
                            option.text = replaceAmountBetweenParentheses(option.text, (totalReviews - languagesCount) + "");
                        }
                    });
                };
                init();
                return {
                    dispose,
                    updateAmounts,
                    selectedLanguage
                };
            }
            content.createReviewLanguageSelect = createReviewLanguageSelect;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initShowMoreElements(containerEl, buttonEl, parameter, elementselector) {
                const elementElsDesktop = eXpress.html.querySelectorAll(containerEl, (elementselector ? elementselector : '.technical-showmore') + '.u-hide-on-desktop-full');
                const elementElsMobile = eXpress.html.querySelectorAll(containerEl, (elementselector ? elementselector : '.technical-showmore') + '.u-hide-on-mobile-full');
                const batchsizeDesktop = parseInt(buttonEl.dataset['batchsizeDesktop'] || '999', 10);
                const batchsizeMobile = parseInt(buttonEl.dataset['batchsizeMobile'] || '999', 10);
                let currentPage = parseInt(buttonEl.dataset.currentpage || '0', 0);
                if (elementElsDesktop.length === 0 && elementElsMobile.length === 0)
                    return;
                const showElements = (sizeMobile, sizeDesktop) => {
                    const toShowDesktop = elementElsDesktop.splice(0, sizeDesktop);
                    toShowDesktop.forEach(e => e.classList.remove('u-hide-on-desktop-full'));
                    if (elementElsDesktop.length === 0) {
                        if (buttonEl.parentElement && !buttonEl.classList.contains('technical-no-hide-parrent'))
                            buttonEl.parentElement.classList.add('u-hide-on-desktop-full');
                        else
                            buttonEl.classList.add('u-hide-on-desktop-full');
                    }
                    const toShowMobile = elementElsMobile.splice(0, sizeMobile);
                    toShowMobile.forEach(e => e.classList.remove('u-hide-on-mobile-full'));
                    if (elementElsMobile.length === 0) {
                        if (buttonEl.parentElement && !buttonEl.classList.contains('technical-no-hide-parrent'))
                            buttonEl.parentElement.classList.add('u-hide-on-mobile-full');
                        else
                            buttonEl.classList.add('u-hide-on-mobile-full');
                    }
                };
                const showMore = () => {
                    currentPage = currentPage + 1;
                    buttonEl.dataset.currentpage = currentPage.toString();
                    let url = location.href;
                    url = eXpress.utils.updateParameter(parameter ? parameter : "currentpage", buttonEl.dataset.currentpage, url);
                    history.replaceState(null, '', url.toLowerCase());
                    showElements(batchsizeMobile, batchsizeDesktop);
                };
                const disposableEvents = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(buttonEl, 'click', showMore)
                ]);
                return {
                    dispose: () => disposableEvents.dispose()
                };
            }
            content.initShowMoreElements = initShowMoreElements;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createTruncate(containerEl, opts) {
                // calculate the height yourself
                // => package does same calculations but with parseInt() so there is no support for float lineheights then visable lines -= 1
                // height of a element auto rounds to a round number do the same here
                const lineHeight = Math.ceil(opts.lineHeight ? opts.lineHeight : parseFloat(window.getComputedStyle(containerEl).lineHeight || "0"));
                const lines = Math.ceil(opts.lines ? opts.lines : 1);
                const maxHeight = Math.ceil(opts.maxHeight ? opts.maxHeight : lineHeight * lines);
                const defaults = {
                    ellipsis: '\u2026 ',
                    showMore: $('.technical-shave-more')[0].outerHTML,
                    showLess: $('.technical-shave-less')[0].outerHTML,
                    lineHeight: lineHeight,
                    lines: lines,
                    maxHeight: maxHeight < lineHeight ? lineHeight : maxHeight // a minimum of 1 line is visible (if max height > line height => no content is shown on the page)
                };
                if (eXpress.html.hasClass(containerEl, "truncate-loading-1-line"))
                    eXpress.html.removeClass(containerEl, "truncate-loading-1-line");
                if (eXpress.html.hasClass(containerEl, "truncate-loading-5-lines--pcp"))
                    eXpress.html.removeClass(containerEl, "truncate-loading-5-lines--pcp");
                const $containerEl = $(containerEl);
                const onClick = (ev) => {
                    const currentEl = ev.target;
                    if (currentEl.classList.contains("technical-shave-more")) {
                        if (opts.eventTrackingMethod && opts.openEventAction)
                            opts.eventTrackingMethod(opts.openEventAction);
                        $containerEl.truncate('expand');
                    }
                    else if (currentEl.classList.contains("technical-shave-less")) {
                        if (opts.eventTrackingMethod && opts.closeEventAction)
                            opts.eventTrackingMethod(opts.closeEventAction);
                        $containerEl.truncate('collapse');
                        containerEl.scrollIntoView();
                    }
                };
                const updateConfig = (newOpts) => {
                    $containerEl.truncate('config', Object.assign(Object.assign({}, newOpts), defaults));
                    $containerEl.truncate('collapse');
                };
                const updateContent = (html) => {
                    $containerEl.truncate('update', html);
                    $containerEl.truncate('collapse');
                };
                const collapse = () => {
                    $containerEl.truncate('collapse');
                };
                $containerEl.truncate(Object.assign(Object.assign({}, opts), defaults));
                containerEl.addEventListener('click', onClick);
                return {
                    dispose: () => containerEl.removeEventListener('click', onClick),
                    updateConfig,
                    updateContent,
                    collapse
                };
            }
            content.createTruncate = createTruncate;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createUserReviews(containerEl, deps, options) {
                const { getReviewsAsync } = deps;
                let { totalAmountOfReviews } = deps; // change when results are loaded
                const { numberOfReviewsToShow = 5, startPageOffset = 0 } = options;
                let { showLoadMoreButton = true } = options;
                const { productReviewsNameLabel, productReviewsAnonymousLabel } = options;
                let pageNumber = 0 + startPageOffset;
                let activeFilter = undefined;
                let activeLanguage = undefined;
                let reviewLanguageSelect;
                // review-blocks
                const reviewBlocksComponent = components.content.createReviewBlocks(eXpress.html.querySelector(containerEl, '.m-review-blocks', true), {
                    productReviewsNameLabel,
                    productReviewsAnonymousLabel
                });
                // show-more control
                const mobileControlEl = eXpress.html.querySelector(containerEl, '.m-review-blocks-controls.u-hide-on-desktop-full', true);
                // pagination control
                const desktopControlEl = eXpress.html.querySelector(containerEl, '.m-review-blocks-controls.u-hide-on-mobile-full', true);
                // amount of page to show
                const numberOfPages = Math.ceil(totalAmountOfReviews / numberOfReviewsToShow);
                const loadNextPage = (page, filter, language, reset = false) => {
                    pageNumber++;
                    let activeLanguageChanged = false;
                    if (reset) {
                        pageNumber = 1;
                        showLoadMoreButton = true;
                        loadMoreButtonComponent.show();
                        loadMoreButtonComponent.enable();
                    }
                    if (page)
                        pageNumber = page;
                    if (filter !== undefined)
                        activeFilter = filter;
                    if (language !== undefined) {
                        // if we change language we reset the star filter
                        activeLanguageChanged = activeLanguage !== language;
                        if (activeLanguageChanged)
                            activeFilter = undefined;
                        activeLanguage = language;
                    }
                    else {
                        // if we click on something in the bars component we need to fetch the initial language (set with the backend code)
                        if (reviewLanguageSelect && reviewLanguageSelect.selectedLanguage) {
                            activeLanguage = reviewLanguageSelect.selectedLanguage;
                        }
                    }
                    loadMoreButtonComponent.disable();
                    getReviewsAsync(pageNumber, activeFilter, activeLanguage)
                        .then(res => {
                        const reviews = res.productCategoryReviews;
                        reviewBlocksComponent.addReviews(reviews, reset);
                        totalAmountOfReviews = res.totalAmountOfReviews;
                        showLoadMoreButton = totalAmountOfReviews >= pageNumber * numberOfReviewsToShow;
                        if (reviewBarsComponent && res.starAmounts) {
                            reviewBarsComponent.updateAmounts(res.totalAmountOfReviews, res.starAmounts, activeLanguageChanged);
                            // for the page component we need to pass the total of the filtered star amounts
                            if (activeFilter) {
                                const filteredAmount = res.starAmounts.filter(a => a.key === activeFilter)[0];
                                if (filteredAmount) {
                                    totalAmountOfReviews = filteredAmount.value;
                                    showLoadMoreButton = totalAmountOfReviews >= pageNumber * numberOfReviewsToShow;
                                }
                            }
                        }
                    })
                        .always(() => {
                        // TODO: function to update ui for components
                        if (!showLoadMoreButton) {
                            loadMoreButtonComponent.hide();
                            loadMoreButtonComponent.disable();
                        }
                        else
                            loadMoreButtonComponent.enable();
                        // update pagination controls
                        paginationControlComponent.updatePaginations(Math.ceil(totalAmountOfReviews / numberOfReviewsToShow), pageNumber);
                    });
                };
                // pagination desktop-control
                const paginationControlComponent = components.content.createPaginationControl(desktopControlEl, {
                    numberOfPages,
                    onClick: page => loadNextPage(page, undefined, undefined, true),
                });
                // show-more control
                const loadMoreButtonComponent = components.content.createShowMoreButton(mobileControlEl, {
                    onClick: loadNextPage,
                });
                // review-bars-links
                const reviewBarsComponent = components.content.createReviewBars(eXpress.html.querySelector(containerEl, '.m-review-bars', true), {
                    onClick: filter => loadNextPage(undefined, filter, undefined, true)
                });
                // review-language-select (Is not always visible => if there is only one language, there's no need to show a language filter)
                const languageSelectorContainerEl = eXpress.html.querySelector(containerEl, '.technical-review-language-selector-container', false);
                if (languageSelectorContainerEl)
                    reviewLanguageSelect = components.content.createReviewLanguageSelect(languageSelectorContainerEl, {
                        onSelect: lang => loadNextPage(undefined, undefined, lang, true)
                    });
                // don't show control if all reviews are already loaded
                if (!showLoadMoreButton) {
                    loadMoreButtonComponent.hide();
                }
                const isMobileControl = () => !eXpress.html.isElementVisible(desktopControlEl);
                let isMobile = isMobileControl();
                const onWindowResize = () => {
                    // if changed -> reset	
                    const isMobileOnResize = isMobileControl();
                    if (isMobile !== isMobileOnResize) {
                        loadNextPage(1, activeFilter, activeLanguage, true);
                        isMobile = isMobileOnResize;
                    }
                };
                window.addEventListener('resize', onWindowResize);
                return {
                    dispose: () => window.removeEventListener('resize', onWindowResize),
                };
            }
            content.createUserReviews = createUserReviews;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function createUsps(containerEl) {
                const iconEls = eXpress.html.querySelectorAll(containerEl, '.m-usp__icon');
                const icons = {};
                eXpress.utils.getInlineSvgsAsync(iconEls
                    .filter(el => !!el.getAttribute('data-icon-url'))
                    .map(el => el.getAttribute('data-icon-url')))
                    .then(res => {
                    res.forEach(icon => icons[icon.url] = icon.svg);
                    iconEls.forEach(el => {
                        const icon = icons[el.getAttribute('data-icon-url').replace("Icon.", "").toLowerCase()];
                        icon && el.insertAdjacentHTML("beforeend", icon);
                    });
                });
            }
            content.createUsps = createUsps;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var content;
        (function (content) {
            function initVideoPlayer(videoContainerEl, autoplayOnClick = true) {
                const playerEl = eXpress.html.querySelector(videoContainerEl, '.technical-video-frame', true);
                const overlayEl = eXpress.html.querySelector(videoContainerEl, '.technical-video-overlay', false);
                const onOverlayClick = (ev) => {
                    ev.preventDefault();
                    if (playerEl.src.toLowerCase().indexOf('youtube') > -1) {
                        hideOverlay();
                        playPauseYoutubeVideo('play');
                    }
                    if (playerEl.src.toLowerCase().indexOf('vimeo') > -1) {
                        const param = eXpress.utils.getParameter('autoplay', playerEl.src.toLowerCase());
                        if (!param)
                            if (playerEl.src.indexOf('?') > -1)
                                playerEl.src = playerEl.src + '&autoplay=1';
                            else
                                playerEl.src = playerEl.src + '?autoplay=1';
                        else
                            eXpress.utils.updateParameter('autoplay', '1', playerEl.src.toLowerCase());
                        hideOverlay();
                    }
                };
                const playPauseYoutubeVideo = (action) => {
                    if (action === "play") {
                        hideOverlay();
                        postMessageToPlayer({
                            "event": "command",
                            "func": "playVideo",
                        });
                    }
                    else {
                        showOverlay();
                        postMessageToPlayer({
                            "event": "command",
                            "func": "pauseVideo",
                        });
                    }
                };
                const hideOverlay = () => {
                    if (overlayEl)
                        overlayEl.classList.add("u-hide");
                };
                const showOverlay = () => {
                    if (overlayEl)
                        overlayEl.classList.remove("u-hide");
                };
                const postMessageToPlayer = (command) => {
                    if (playerEl && playerEl.contentWindow) {
                        playerEl.contentWindow.postMessage(JSON.stringify(command), "*");
                    }
                };
                const init = () => {
                    if (overlayEl && autoplayOnClick)
                        eXpress.html.addEventListener(overlayEl, 'click', onOverlayClick);
                };
                init();
                return {
                    dispose: () => { if (overlayEl)
                        eXpress.html.addEventListener(overlayEl, 'click', onOverlayClick); },
                    playPauseYoutubeVideo: (action) => playPauseYoutubeVideo(action),
                    showOverlay,
                    isOverlayVisible: () => {
                        return overlayEl && !overlayEl.classList.contains("u-hide");
                    }
                };
            }
            content.initVideoPlayer = initVideoPlayer;
        })(content = components.content || (components.content = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
